import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";
import Home from "./pages/Home";
import AdminDashboard from "./pages/AdminDashboard";
import MyAppointments from "./pages/MyAppointments";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SimulatorPage from "./pages/SimulatorPage";
import SubmitReviewPage from "./pages/SubmitReviewPage";
import WrapDesignerPage from "./pages/WrapDesignerPage";
import ChromeDeletePage from "./pages/ChromeDeletePage";
import StarlightsPage from "./pages/StarlightsPage";
import AmbientLightingPage from "./pages/AmbientLightingPage";
import TintRemovalSimPage from "./pages/TintRemovalSimPage";
import VinylWrapQuotePage from "./pages/VinylWrapQuotePage";
import { PromoProvider } from "./components/DiscountedPrice";

// Force iOS Safari to not restore scroll position across navigations
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function ScrollToTop() {
  const { pathname } = useLocation();
  const skipScroll = new URLSearchParams(window.location.search).get('openCategory');
  useLayoutEffect(() => {
    if (skipScroll) return;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // Use both methods — iOS Safari honours document.documentElement, not window
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [pathname, skipScroll]);
  useEffect(() => {
    if (skipScroll) return;
    // requestAnimationFrame fires after paint — catches iOS late-reflow scroll restoration
    const raf = requestAnimationFrame(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    });
    // Belt-and-suspenders: a second pass 80 ms later for slow iOS devices
    const t = setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }, 80);
    return () => { cancelAnimationFrame(raf); clearTimeout(t); };
  }, [pathname, skipScroll]);
  return null;
}

import { TextUsButton } from "./components/TextUsButton";

function App() {
  return (
    <div className="App">
      <PromoProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/my-appointments" element={<MyAppointments />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/simulator" element={<SimulatorPage />} />
          <Route path="/submit-review" element={<SubmitReviewPage />} />
          <Route path="/wrap-designer" element={<WrapDesignerPage />} />
          <Route path="/vinyl-wrap" element={<WrapDesignerPage />} />
          <Route path="/vinyl-wrap-quote" element={<VinylWrapQuotePage />} />
          <Route path="/chrome-delete" element={<ChromeDeletePage />} />
          <Route path="/starlights" element={<StarlightsPage />} />
          <Route path="/ambient-lighting" element={<AmbientLightingPage />} />
          <Route path="/tint-removal" element={<TintRemovalSimPage />} />
          <Route path="/gallery" element={<Navigate to="/submit-review" replace />} />
          <Route path="/reviews" element={<Navigate to="/submit-review" replace />} />
          <Route path="/review" element={<Navigate to="/submit-review" replace />} />
          <Route path="/status" element={<Navigate to="/my-appointments" replace />} />
        </Routes>
        
      </BrowserRouter>
      </PromoProvider>
    </div>
  );
}

export default App;
